/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { FormConfig } from "@src/app/shared/form/FormConfig";
import { FieldSet } from "@src/app/shared/form/field-set/field-set.component";
import { FormButtonComponent } from "@src/app/shared/form/form-button/form-button.component";
import { FormTextComponent } from "@src/app/shared/form/form-text/form-text.component";
import { FormNumberComponent } from "@src/app/shared/form/form-number/form-number.component";
import { Panel } from "@src/app/modules/txn/bank-reconciliation/panel";
import { FormDateComponent } from "@src/app/shared/form/form-date/form-date.component";
import { PurchasePageComponent } from "@src/app/modules/txn/purchase-page/purchase-page.component";
import { PreferredSupplierPageComponent } from "@src/app/modules/supply/preferred-supplier-page/preferred-supplier-page.component";
import { BankOutPageComponent } from "@src/app/modules/txn/bank-out-page/bank-out-page.component";
import { MyInjector } from "@src/app/app.module";
import { MatDialog } from "@angular/material/dialog";
import { SupplierService } from "@src/app/modules/supply/supplier.service";
import { Txn } from "@src/app/model/txn";
import { HttpParams } from "@angular/common/http";
import { PreferredSupplier } from "@src/app/model/supplier";

export const purchasePanel: Panel = new Panel({
    type: 'purchases',
    icon: 'shopping_basket',
    takeAction(txn: Txn) {
        const dialog = MyInjector.instance.get(MatDialog);
        const supplierSvc = MyInjector.instance.get(SupplierService);
        supplierSvc.get<PreferredSupplier>(false, new HttpParams().set('id',txn.supplierId)).subscribe( suppliers => {
            if (suppliers && suppliers.length === 1) {
                const data = { supplier: suppliers[0], bankItem: this.item, bankAccount: this.bankAccount }
                dialog.open(BankOutPageComponent, { data }).afterClosed().subscribe(result => {
                    if (result) {
                        this.recItemsComponent.removeItem(this.item);
                        this.reconciliationComponent.showPanel = null;
                    }
                });
            }
        })
    },
    setTitle() {
        this._title = this._items?.length + ' Unpaid purchase invoices'
    },
    setConfig() {
        return new FormConfig({
            fieldSet: new FieldSet({
                fields: [
                    FormButtonComponent.makeDialogOpenButton('Invoice', 'refNr', 'id', PurchasePageComponent),
                    FormButtonComponent.makeDialogOpenButton('Supplier', 'supplierName', 'supplierId', PreferredSupplierPageComponent),
                    FormTextComponent.make('Supplier Ref', 'reference'),
                    FormDateComponent.make('Date', 'txnDate'),
                    FormNumberComponent.makeCurrency('Total', 'credit'),
                    FormNumberComponent.makeCurrency('Outstanding', 'outstanding'),
                    FormNumberComponent.makeCurrency('Difference', 'diffAmount'),
                    FormButtonComponent.makeTableButton('Match', 'match', this.takeAction.bind(this)).override({
                        calculateValue: () => 'Pay',
                    }),
                ],
            }),
            mode: 'list'
        })
    }
})
